module.exports = __webpack_public_path__ + "img/user.e94c15f3.svg";